const __default__ = {
  name: "MonthlyStudentTable",
  props: {
    student: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    days: {
      type: Number,
      default: 30
    },
    monthData: {
      type: Array,
      default: () => []
    },
    displayLabel: {
      type: String,
      default: ""
    }
  },

  data() {
    return {};
  },

  computed: {},
  methods: {
    handleCommentEdit(student) {
      this.$emit("handleCommentEdit", student);
    },

    getAttendanceClass(attendance) {
      if (!attendance) {
        return null;
      }

      const type = attendance.type.split("-")[0];

      if (type === "欠席") {
        return "type_absence";
      } else if (type === "遅刻早退") {
        // 暫定的に早退と同じ色で表示している
        return "type_early";
      } else if (type === "早退") {
        return "type_early";
      } else if (type === "遅刻") {
        return "type_late";
      }
    },

    getAttendanceLabel(attendance) {
      if (!attendance) {
        return null;
      }

      if (this.displayLabel === "code") {
        return attendance.counting_type ? attendance.counting_type.glyph : attendanceLabels[attendance.type.split("-")[0]].code;
      } else if (this.displayLabel === "book" && attendance.attendance_type) {
        return attendance.attendance_type.attendance_book_label;
      } else {
        return attendance.type.split("-")[0];
      }
    }

  }
};
import { useAbsentAlertStore } from "@/stores/absentAlert";
import { attendanceLabels } from "@/consts/attendanceLabels";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const absentAlertStore = useAbsentAlertStore();
    return {
      __sfc: true,
      absentAlertStore
    };
  }

});